import React, { useState } from 'react';

const galleryImages = [
  '9.webp', '1.webp', '2.webp', '3.webp', '4.webp', '5.webp', '6.webp', '7.webp', '8.webp', '10.webp', '11.webp', '12.webp', '13.webp'
];

export default function Gallery() {
  const [current, setCurrent] = useState(0);
  const total = galleryImages.length;

  const prevImage = () => setCurrent((current - 1 + total) % total);
  const nextImage = () => setCurrent((current + 1) % total);

  return (
    <section className="gallery" id="gallery">
      <h2>Фотогалерея</h2>
      <div className="gallery-container" data-aos="fade-up">
        <button className="gallery-nav prev-btn" aria-label="Previous photo" onClick={prevImage}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div className="gallery-content">
          {galleryImages.map((img, i) => (
            <img
              src={`/images/${img}`}
              alt={`Галерея ${i + 1}`}
              className={`gallery-image ${i === current ? 'active' : ''}`}
              loading="lazy"
              width="800"
              height="600"
              key={img}
            />
          ))}
        </div>
        <button className="gallery-nav next-btn" aria-label="Next photo" onClick={nextImage}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </section>
  );
}